import Vue from 'vue'
import VueUA from '@jarvisniu/vue-ua'

Vue.use(VueUA)
